import Chip from 'lib/Chip';
import { Size } from 'lib/Chip/Chip.types';
import { CircularLoadingSpinner, SpinnerSize } from 'lib/CircularLoadingSpinner/CircularLoadingSpinner';
import { bookingStatusStyles, defaultBookingStatusStyle } from 'components/common/Deal/ChipBookingStatus/consts';
import CopyToClipboardCellRenderer from 'components/common/CopyToClipboardCellRenderer';
import Tooltip, { TooltipSize } from 'lib/Tooltip';
import DataListProps from './DataList.types';

const DataList = ({
  data,
  variant,
  isDealIdHidden,
  isLoadingDealOptions = false,
}: {
  data: DataListProps;
  variant: 'chip' | 'option';
  isDealIdHidden?: boolean;
  isLoadingDealOptions?: boolean;
}): React.ReactElement | null => {
  const statusStyle =
    data.status != null ? (bookingStatusStyles[data.status] ?? defaultBookingStatusStyle) : defaultBookingStatusStyle;

  const status = (
    <>
      {data?.status === undefined && isLoadingDealOptions && (
        <span className="py-4 pr-4">
          <CircularLoadingSpinner size={SpinnerSize.SMALL} />
        </span>
      )}
      {data?.status !== undefined && <Chip label={statusStyle.text} color={statusStyle.style} size={Size.SMALL} />}
    </>
  );

  if (variant === 'chip') {
    return (
      <div className="flex w-full min-w-0 items-center gap-2">
        <div className="min-w-0 flex-1">
          <Tooltip
            size={TooltipSize.FULL}
            wrapperClassName="truncate body-base font-medium text-neutral-900"
            tooltip={data.title || data.subText}
          >
            {data.title || data.subText}
          </Tooltip>
        </div>
        <div className="ml-auto flex min-w-0 items-center gap-2">
          {!isDealIdHidden && (
            <Tooltip tooltip={data.subText}>
              <div
                className="min-w-0"
                role="presentation"
                onMouseDown={(e) => e.stopPropagation()}
                onClick={(e) => e.stopPropagation()}
              >
                <CopyToClipboardCellRenderer
                  value={data.subText}
                  isIconAlwaysVisible
                  customClasses="text-neutral-500 !p-0 min-w-0"
                  customIconClasses="!text-neutral-400 group-hover/copy:!text-neutral-600"
                />
              </div>
            </Tooltip>
          )}
          <div className="flex w-24 shrink-0 justify-end">{status}</div>
        </div>
      </div>
    );
  }

  return (
    <div>
      <div className="flex items-center justify-between gap-2">
        <span className="body-base truncate font-medium text-neutral-900 min-w-0">{data.title || data.subText}</span>
        {status}
      </div>
      {!isDealIdHidden && <span className="body-sm text-neutral-500">{data.subText}</span>}
    </div>
  );
};

export default DataList;
